var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h2',[_vm._v("Settings")]),_c('accountComponent'),_c('emailComponent',{attrs:{"user":_vm.userDetail}}),_c('phoneComponent',{attrs:{"user":_vm.userDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }